export const SUPPORTED_LOCALES = [
  'ja',
  'en',
  'ko',
  'zh-Hans',
  'zh-Hant',
  'es',
  'fr',
  'de',
  'it',
  'pt-BR',
  'id',
  'th',
  'vi',
  'hi',
  'ar',
  'ru',
  'tr',
  'nl',
] as const

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export const LOCALE_DISPLAY_NAMES: Record<SupportedLocale, string> = {
  ja: '日本語',
  en: 'English',
  ko: '한국어',
  'zh-Hans': '简体中文',
  'zh-Hant': '繁體中文',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  it: 'Italiano',
  'pt-BR': 'Português (Brasil)',
  id: 'Bahasa Indonesia',
  th: 'ไทย',
  vi: 'Tiếng Việt',
  hi: 'हिन्दी',
  ar: 'العربية',
  ru: 'Русский',
  tr: 'Türkçe',
  nl: 'Nederlands',
}

const LOCALE_SET = new Set<string>(SUPPORTED_LOCALES)

export function resolveSupportedLocale(language: string | undefined): SupportedLocale {
  const normalized = (language ?? '').trim()
  if (LOCALE_SET.has(normalized)) return normalized as SupportedLocale

  const lower = normalized.toLowerCase()
  if (lower.startsWith('zh-tw') || lower.startsWith('zh-hk')) return 'zh-Hant'
  if (lower.startsWith('zh')) return 'zh-Hans'
  if (lower.startsWith('pt-br')) return 'pt-BR'

  const base = lower.split('-')[0]
  const match = SUPPORTED_LOCALES.find((locale) => locale.toLowerCase().split('-')[0] === base)
  return match ?? 'ja'
}
